import classNames from 'classnames';
import * as React from 'react';

import { MenuTopic } from './menu-topic';

type Props = {
  selectedTopic?: number;
  selectTopic: (index: number) => void;
  closeTopic: () => void;
};

export class MenuTopics extends React.Component<Props> {
  private selectTopic = (index: number) => () => {
    const { selectTopic } = this.props;

    selectTopic(index);
  }

  public render() {
    const { selectedTopic, closeTopic } = this.props;

    return (
      <div className="menu-topics">
        {
          topics.map((topic, index) => (
            <MenuTopic key={topic.title} topic={topic} onSelect={this.selectTopic(index)} />
          ))
        }

        <div
          className={classNames('menu-topics__content', {
            'menu-topics__content--open': selectedTopic !== undefined,
          })}
        >
          {selectedTopic === undefined ? null : <MenuTopic topic={topics[selectedTopic]} onClose={closeTopic} />}
        </div>
      </div>
    );
  }
}

const topics = [
  {
    title: 'dolce vita specials',
    bgImage: 'DSC_0818',
    items: [
      {
        name: 'avocado toast met ei',
        description: 'Met roerei en prosciutto',
        en: 'With scrambled egg and prosciutto',
        price: 6.95,
      },
      {
        name: 'avocado toast met gerookte zalm',
        description: 'Met rode ui, komkommer en radijs',
        en: 'With red onion, cucumber and radish',
        price: 8.95,
      },
      {
        name: 'omelet veggie',
        description: 'Met gegrilde aubergine, courgette en champignons',
        en: 'With grilled egg plant, zucchini and mushrooms',
        price: 7.25,
      },
      {
        name: 'omelet dolce vita',
        description: 'Met paprika, chorizo, champignons en kaas',
        en: 'With bell pepper, chorizo, mushrooms and cheese',
        price: 8.95,
      },
    ],
  },
  {
    title: 'gegrilde panini\'s',
    bgImage: 'DSC_0743',
    items: [
      {
        name: 'caprese',
        description: 'Mozzarella, zondgedroogde tomaten, basilicum en pesto',
        en: 'Mozzarella, sundried tomatoes, basil and pesto',
        price: 7.95,
      },
      {
        name: 'veggie',
        description: 'Mozzarella, gegrilde courgette en aubergine',
        en: 'Mozzarella, grilled zucchini and egg plant',
        price: 8.5,
      },
      {
        name: 'parmozza',
        description: 'Mozzarella, parmaham en pesto',
        en: 'Mozzarella, parmaham and pesto',
        price: 8.95,
      },
    ],
  },
  {
    title: 'sandwiches',
    bgImage: 'DSC_0743',
    items: [
      {
        name: 'brie',
        description: 'Met pesto, rucola, honing en walnoten',
        en: 'With pesto, rocket, honey and wallnuts',
        price: 7.5,
      },
      {
        name: 'gegrilde pikante kip',
        description: 'Met avocado en prosciutto',
        en: 'With avocado and prosciutto',
        price: 8.25,
      },
      {
        name: 'tonno',
        description: 'Met tonijnsalade',
        en: 'With tuna salad',
        price: 8.25,
      },
      {
        name: 'gerookte zalm',
        description: 'Met rode uien, roomkaas en kappertjes',
        en: 'With red onion, cream cheese and capers',
        price: 9.25,
      },
      {
        name: 'tartufo',
        description: 'Rosbief en truffelmayonaise',
        en: 'Roast beef and truffle mayonnaise',
        price: 10.5,
      },
      {
        name: 'club sandwich',
        description: 'Met gerookte kip, prosciutto, kaas, sla, tomaat en chips',
        en: 'With smoked chicken, prosciutto, cheese, lettuce, tomatoe and chips',
        price: 11.5,
      },
    ],
  },
  {
    title: 'voorgerechten',
    bgImage: 'DSC_0764',
    items: [
      {
        name: 'brood',
        description: 'Met kruidenboter en tapenade',
        en: 'With herb butter and tapenade',
        price: 11.5,
      },
      {
        name: 'bruschetta',
        description: 'Gegrilde brood met tomaten, pesto en kaas',
        en: 'Grilled bread with tomatoes, pesto and cheese',
        price: 6.95,
      },
      {
        name: 'polpette',
        description: 'Drie gehaktballetjes in tomatensaus',
        en: 'Three meatballs in tomatoe sauce',
        price: 8.95,
      },
      {
        name: 'italiaanse plank',
        description: 'Met olijven, gevulde dadels, carpaccio, tapenade en kaas',
        en: 'With olives, stuffed dates, carpaccio, tapenade and cheese',
        price: 13.5,
      },
    ],
  },
  {
    title: 'pasta\'s',
    bgImage: 'DSC_0803',
    items: [
      {
        name: 'spaghetti aglio e olio',
        description: 'Met knoflook, olijfolie, rode peper en peterselie',
        en: 'With garlic, olive oil, chili pepper and parsley',
        price: 12.5,
      },
      {
        name: 'spaghetti alla norma',
        description: 'Met aubergine en tomatensaus',
        en: 'With egg plant en tomatoe sauce',
        price: 14.5,
      },
      {
        name: 'cannelloni veggie',
        description: 'Gevuld met ricotta en spinazie',
        en: 'Filled with ricotta and spinach',
        price: 13.95,
      },
      {
        name: 'bolognese',
        description: 'Rijke vleessaus met tomaten en groenten',
        en: 'Rich meat sauce with tomatoes and vegetables',
        price: 15.95,
      },
      {
        name: 'lasagna bolognese',
        description: 'Rijke vleessaus met tomaten, groenten en bechamel',
        en: 'Rich meat sauce with tomatoes, vegetables and bechamel',
        price: 15.95,
      },
      {
        name: 'al gamberi',
        description: 'Met knoflook, rode peper en peterselie',
        en: 'With garlic, chili pepper and parsley',
        price: 16.95,
      },
    ],
  },
  {
    title: 'pizza\'s',
    bgImage: 'DSC_0744',
    items: [
      {
        name: 'margarita',
        description: 'Met mozzarella, basilicum en tomaten',
        en: 'With mozzarella, basil and tomatoes',
        price: 12.95,
      },
      {
        name: 'veggie',
        description: 'Met gegrilde groenten en champignons',
        en: 'With grilled vegetables and mushrooms',
        price: 14.95,
      },
      {
        name: 'dolce vita',
        description: 'Met chorizo, mozzarella, paprika en champignons',
        en: 'With chorizo, mozzarella, bell pepper and mushrooms',
        price: 15.95,
      },
      {
        name: 'hot & spicy',
        description: 'Met pikante kip, champignons, paprika en olijven',
        en: 'With spicy chicken, mushrooms, bell pepper and olives',
        price: 17.50,
      },
    ],
  },
  {
    title: 'soepen',
    bgImage: 'DSC_0744',
    items: [
      {
        name: 'pomodoriesoep',
        description: 'Tomatensoep met basilicum en knoflook',
        en: 'Tomatoe soup with basil and garlic',
        price: 6.5,
      },
      {
        name: 'soep van de dag',
        description: 'Vraag aan de bediening',
        en: 'Ask the waiters',
        price: 6.5,
      },
    ],
  },
  {
    title: 'maaltijdsalades',
    bgImage: 'DSC_0744',
    items: [
      {
        name: 'pesto pasta salad',
        description: 'Met groene pesto, tomaten, rode ui en komkommer',
        en: 'With green pesto, tomatoes, red onion and cucumber',
        price: 9.95,
      },
      {
        name: 'trapani pasta salad',
        description: 'Pesto van amandelen, basilicum en tomaten',
        en: 'Almond pesto, basil and tomatoes',
        price: 9.95,
      },
      {
        name: 'caesar salad',
        description: 'Met gegrilde kip, gekookte ei, prosciutto en croutons',
        en: 'With grilled chicken, boiled egg, prosciutto and croutons',
        price: 13.5,
      },
      {
        name: 'nicoise salad',
        description: 'Met tonijn, haricots verts, gekookte ei, tomaten en komkommer',
        en: 'With tuna, green beans, boiled egg, tomatoes and cucumber',
        price: 13.5,
      },
    ],
  },
  {
    title: 'desserts',
    bgImage: 'DSC_0784',
    items: [
      {
        name: 'tiramisu',
        description: 'Laagjes gebak met lange vingers gedrenkt in koffie en amaretto',
        en: 'Layers of pastry with ladyfingers drenched in coffee and amaretto',
        price: 5.5,
      },
      {
        name: 'souffle al cioccolato',
        description: 'Chocoladecakeje met een hart van warme chocolade',
        en: 'Chocolate cake with hot melted chocolate in the center',
        price: 5.5,
      },
      {
        name: 'dessert van de week',
        description: 'Vraag aan de bediening',
        en: 'Ask the waiters',
        price: 5.5,
      },
    ],
  },
  {
    title: 'frisdranken',
    bgImage: 'DSC_0791',
    items: [
      {
        name: 'coca cola',
        description: '',
        price: 2.75,
      },
      {
        name: 'coca cola zero',
        description: '',
        price: 2.75,
      },
      {
        name: 'lipton ice tea',
        description: '',
        price: 3.25,
      },
      {
        name: 'ice coffee',
        description: '',
        price: 3.25,
      },
      {
        name: 'verse volle melk',
        description: '',
        price: 2.25,
      },
      {
        name: 'jus d\'orange klein',
        description: '',
        price: 2.95,
      },
      {
        name: 'jus d\'orange groot',
        description: '',
        price: 3.95,
      },
      {
        name: 's. pellegrino tonic',
        description: '',
        price: 2.75,
      },
      {
        name: 's. pellegrino limonata',
        description: '',
        price: 2.75,
      },
      {
        name: 's. pellegrino aranciata',
        description: '',
        price: 2.75,
      },
      {
        name: 's. pellegrino aranciata rossa',
        description: '',
        price: 2.75,
      },
      {
        name: 'zuegg appelsap',
        description: '',
        price: 2.75,
      },
      {
        name: 's. pellegrino aqua',
        description: '',
        price: 2.75,
      },
      {
        name: 'aqua panna zonder koolzuur',
        description: '',
        price: 2.75,
      },
      {
        name: 'sp aqua 0,75 liter',
        description: '',
        price: 7.5,
      },
      {
        name: 'ap 0.75 liter',
        description: '',
        price: 7.5,
      },
    ],
  },
  {
    title: 'warme dranken',
    bgImage: 'DSC_0739',
    items: [
      {
        name: 'espresso',
        description: '',
        price: 2,
      },
      {
        name: 'espresso con panna',
        description: '',
        price: 2.25,
      },
      {
        name: 'espresso macchiato',
        description: '',
        price: 2.25,
      },
      {
        name: 'dubbele espresso',
        description: '',
        price: 3.5,
      },
      {
        name: 'lungo',
        description: '',
        price: 2.5,
      },
      {
        name: 'lungo con panna',
        description: '',
        price: 2.75,
      },
      {
        name: 'cappuccino',
        description: '',
        price: 2.75,
      },
      {
        name: 'dubbele cappuccino',
        description: '',
        price: 4.25,
      },
      {
        name: 'cappuccino con panna',
        description: '',
        price: 3,
      },
      {
        name: 'caffe latte',
        description: '',
        price: 2.75,
      },
      {
        name: 'latte macchiatto',
        description: '',
        price: 3.5,
      },
      {
        name: 'hot choco de lux',
        description: '',
        price: 3.5,
      },
      {
        name: 'thee',
        description: '',
        price: 2.25,
      },
      {
        name: 'chai tea latte',
        description: '',
        price: 3.75,
      },
      {
        name: 'verse munt thee',
        description: '',
        price: 3.25,
      },
    ],
  },
];
